import React, { useReducer } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { useConnectedRouter } from '../../hooks/useConnectedRouter';
import { useAppSelector } from '../../redux/hooks';
import { selectIsBot } from '../../redux/slices/utils-slice';
import type { Category } from '../../types/api';
import { NoSSR } from '../../utils/ssr';
import { isBrowser } from '../../utils/web';
import { WebsiteCustomLogo } from '../Website/WebsiteLogo';

const messages = defineMessages({
  guide1: {
    defaultMessage:
      'On our forums and in the {title} section, some content may offend the sensibilities of younger and/or unprepared audiences.',
    id: 'pKcWMS',
  },
  guide2: {
    defaultMessage: 'If this is your case, we recommend you return to the homepage of the site.',
    id: 'OICN/2',
  },
  consentAdult: { defaultMessage: 'I certify that I am of legal age', id: '3bacVu' },
  refuseAdult: { defaultMessage: 'I return to the homepage', id: 'ifnw9N' },
});

const AdultConsent: React.FC<{ tag: Category }> = ({ tag }) => {
  const { push } = useConnectedRouter();
  const [accepted, setAccepted] = useReducer(
    (_: unknown, isAccepted: boolean) => {
      if (isBrowser) {
        localStorage.setItem('adult-consent', isAccepted.toString());
        if (!isAccepted) push('/');
      }
      return isAccepted;
    },
    isBrowser ? localStorage.getItem('adult-consent') === 'true' : true,
  );
  const isBot = useAppSelector(selectIsBot);

  return (
    <NoSSR>
      {accepted || !isBrowser || isBot ? null : (
        // Wrapper div to avoid having margin on the .modal element, which happens due to a space-y on the parent div.
        <div>
          <div className="modal">
            <div className="modal-content relative p-4 md:px-14 md:py-6">
              <h1 className="adult-consent-title">
                <WebsiteCustomLogo forceKind="legacy" />
              </h1>
              <div className="adult-consent-heading">Attention</div>
              <div className="adult-consent-explain">
                <FormattedMessage {...messages.guide1} values={{ title: tag.title }} />
                <br />
                <br />
                <strong>
                  <FormattedMessage {...messages.guide2} />
                </strong>
              </div>
              <div className="adult-consent-buttons">
                <button type="button" onClick={() => setAccepted(true)}>
                  <b>OUI</b>
                  <FormattedMessage {...messages.consentAdult} />
                </button>
                <button type="button" onClick={() => setAccepted(false)}>
                  <b>NON</b>
                  <FormattedMessage {...messages.refuseAdult} />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </NoSSR>
  );
};

export default AdultConsent;
